import type { FC, Ref } from 'react';

import { ImageListItem, Typography } from '@mui/material';
import { Item } from 'react-photoswipe-gallery';

import { FallbackImage } from '../../../../../base';
import { DEFAULT_SIZE, IMAGE_SIZE } from '../constants';
import type { ImageItemType } from '../types';

type Props = {
  index: number;
  originalImage: ImageItemType;
  thumbnailImage: ImageItemType;
  maxImageIndex: number;
  countImages?: number;
};

const ImageItem: FC<Props> = ({ index, originalImage, thumbnailImage, maxImageIndex, countImages }) => (
  <ImageListItem
    key={index}
    sx={{
      width: IMAGE_SIZE,
      cursor: 'pointer',
      borderRadius: '4px',
      overflow: 'hidden',
      display: index > maxImageIndex ? 'none' : 'flex',
    }}
  >
    {countImages && (
      <Typography
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textShadow: '-1px -1px 0 #b8b8b8, 1px -1px 0 #b8b8b8, -1px 1px 0 #b8b8b8, 1px 1px 0 #b8b8b8',
          backgroundColor: '#7070703d',
          pointerEvents: 'none',
        }}
        color='#ffffff'
        variant='h5'
      >
        {countImages}
      </Typography>
    )}
    <Item
      cropped
      original={originalImage.url}
      thumbnail={thumbnailImage.url}
      width={originalImage.width ?? DEFAULT_SIZE}
      height={originalImage.height ?? DEFAULT_SIZE}
    >
      {({ ref, open }) => (
        <FallbackImage
          sx={{
            height: IMAGE_SIZE,
            objectFit: 'cover',
          }}
          src={thumbnailImage.url}
          ref={ref as Ref<HTMLImageElement>}
          onClick={open}
          aria-hidden='true'
        />
      )}
    </Item>
  </ImageListItem>
);

export default ImageItem;
